import { makeImmutable } from "../../../core";
export class PreorderSettingsBuffer {
    constructor(addWorkdays) {
        this.addWorkdays = addWorkdays;
        makeImmutable(this);
    }
    static fromMinDays(minDays) {
        switch (minDays) {
            case 0:
                return PreorderSettingsBuffer.Disabled;
            case -1:
                return PreorderSettingsBuffer.Tomorrow;
            default:
                return new PreorderSettingsBuffer(minDays + 1);
        }
    }
    eq(other) {
        return this.addWorkdays === other.addWorkdays;
    }
    min(other) {
        if (this.addWorkdays === null) {
            return PreorderSettingsBuffer.Disabled;
        }
        if (other.addWorkdays === null) {
            return PreorderSettingsBuffer.Disabled;
        }
        return new PreorderSettingsBuffer(Math.min(this.addWorkdays, other.addWorkdays));
    }
}
PreorderSettingsBuffer.Disabled = new PreorderSettingsBuffer(null);
PreorderSettingsBuffer.Tomorrow = new PreorderSettingsBuffer(1);
